var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Header"},[_c('div',{staticClass:"nav"}),_vm._v(" "),_c('mt-header',{staticClass:"remind-head",attrs:{"title":"添加提醒","fixed":""}},[_c('router-link',{attrs:{"slot":"left","to":"/reminder"},slot:"left"},[_c('img',{attrs:{"src":require("../assets/reminder/left.png")}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43cc427d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"audio":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 